<template>
    <el-tag>{{ getMessage() }}</el-tag>
</template>
<script>
export default {
    props: ['detail'],
    data() {
        return {}
    },
    methods: {
        getMessage() {
            return this.detail.message.data&&this.detail.message.data.title||'未知';
        }
    }
}
</script>
<style scoped lang="less">

</style>